import type { CaptureFileJSONObject } from '@ikegps/core-api';
import { SVGRenderer } from '@ikegps/core-shared';
import { CollectionModel } from '@ikegps/core-shared';
import { addStyles } from '../../components/theme';
import type { MithrilVNode } from '../../mithril';
import { m } from '../../mithril';
import { Services } from '../../services';
import { classNames } from '../../util/classnames';
import { HiddenImageIcon } from '../hidden.image.icon/hidden.image.icon';
import { CSS, Style } from './capture.thumbnail.style';

addStyles(Style);

export interface CaptureThumbnailCtx {
	crosshair?: boolean;
	truesize?: boolean;
	selected?: boolean;
	className?: string;
	size?: number;
	title?: string;
	icon?: boolean;
	action?: (ev: MouseEvent) => void;
}

const DEFAULT_THUMBNAIL_SIZE = 180;

export const CaptureThumbnail = {
	view(collection: CollectionModel, capture: CaptureFileJSONObject, ctx: CaptureThumbnailCtx = {}): MithrilVNode {
		const draw = Services.DrawState.getIkeDraw(collection, capture.objectId);
		const className = classNames(CSS.container, ctx.className, {
			[CSS.selectable]: typeof ctx.action === 'function',
			[CSS.selected]: ctx.selected,
			[CSS.hiddenCapture]: draw.state.imageVisibilityHidden,
		});
		const title = ctx.title;
		const onclick = ctx.action;
		const src = capture.thumbnail != null ? capture.thumbnail.url : capture.file.url;

		const size = {
			width: DEFAULT_THUMBNAIL_SIZE,
			height: DEFAULT_THUMBNAIL_SIZE,
		};
		if (ctx.size) {
			size.width = ctx.size;
			size.height = ctx.size;
		}

		const renderCtx = {
			draw,
			size,
			units: Services.UserSettings.units,

			isThumbnail: true,
			isInteractive: false,
			isEditable: false,
			scale: SVGRenderer.scaleUI(draw.state, true),
		};

		return m('div', { className, title, onclick }, [
			ctx.truesize || draw.state.brightness !== 1
				? m('div', { className: CSS.overlay }, SVGRenderer.view(renderCtx))
				: m('img', { className: CSS.image, src }),
			ctx.crosshair && m('div', { className: CSS.crosshair }),
			ctx.truesize && ctx.icon && m('div', { className: CSS.photomeasure }),
			draw.state.imageVisibilityHidden && HiddenImageIcon.view(),
			m('div', { className: CSS.date }, Services.DateTime.formatDate(capture.collectedAt.iso)),
		]);
	},
};
